import { render, staticRenderFns } from "./OrderDiagnostics.vue?vue&type=template&id=5b632553"
import script from "./OrderDiagnostics.vue?vue&type=script&lang=js"
export * from "./OrderDiagnostics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports